module.exports = __webpack_public_path__ + "img/room.4e30e25e.svg";